module.exports = __webpack_public_path__ + "img/fiji.d6220f2.webp";